



























import { Component, Vue } from 'vue-property-decorator';
import Button from '@/components/Button.vue';

const SHARE_URL = 'https://www.example.com';
@Component({
  components: {
    Button,
  },
})
export default class SocialMediaShareElement extends Vue {
  private primaryText: string | null = null;
  private isNativeShareSupported = true;
  private socialMediaLinks = {
    twitter: 'https://twitter.com/intent/tweet',
    facebook: 'https://www.facebook.com/',
    linkedin: 'https://www.linkedin.com/',
  };

  async created() {
    this.primaryText = this.$store.state.reviewText;
    if (navigator.share === undefined) {
      this.isNativeShareSupported = false;
    }
  }

  private async shareOnTwitter() {
    let shareUrl;
    if (this.primaryText) {
      const hashtags = this.findHashtags(this.primaryText);
      let localHashtags: string[] = [];
      let localText = this.primaryText;
      if (hashtags.length > 0) {
        hashtags.forEach(item => {
          localText = localText.replace(item, '');
        });
        localHashtags = hashtags.map(item => {
          return item.replace('#', '');
        });
      }

      shareUrl = `${
        this.socialMediaLinks.twitter
      }?text=${localText}&url=${SHARE_URL}&hashtags=${localHashtags.join()}`;
    } else {
      shareUrl = this.socialMediaLinks.twitter;
    }
    window.open(shareUrl, '_blank');
  }
  findHashtags(text: string) {
    var regexp = /\B\#\w\w+\b/g;
    var result = text.match(regexp);
    return result || [];
  }
  private async shareOnDesktop(url: string) {
    await this.modifyClipBoardContent();

    window.open(url, '_blank');
  }

  async modifyClipBoardContent() {
    if (!this.primaryText) return;
    const modifiedText = `${this.primaryText}\n ${SHARE_URL}`;
    await navigator.clipboard.writeText(modifiedText);
  }
  async shareOnSocialMedia() {
    if (!this.primaryText) {
      await navigator.share({ url: SHARE_URL });
      return;
    }
    const data = {
      url: SHARE_URL,
      text: `${this.primaryText!}`,
    };
    await navigator.clipboard.writeText(data.text);

    await navigator.share(data);
  }
}
